import { COLORS } from "../../../../../theme/colors";

const RECTANGLE_WIDTH = 40;
const RECTANGLE_HEIGHT = 12;
const RECTANGLE_RADIUS = 3;
const RECTANGLE_STYLE = { transform: `translate(-${RECTANGLE_WIDTH / 2}px)` };

export function CurrentDateCustomLabel({ viewBox }) {
  return (
    <svg>
      <rect
        x={viewBox.x}
        y={viewBox.y + viewBox.height + RECTANGLE_HEIGHT / 2}
        width={RECTANGLE_WIDTH}
        height={RECTANGLE_HEIGHT}
        style={RECTANGLE_STYLE}
        rx={RECTANGLE_RADIUS}
        fill={COLORS.black[0][100]}
      />
      <text
        x={viewBox.x}
        y={viewBox.y + viewBox.height + 16}
        textAnchor="middle"
        fill={COLORS.white}
        fontSize={10}
        fontWeight={700}
      >
        NOW
      </text>
    </svg>
  );
}
